import { handleActions } from 'redux-actions';
import { createSelector } from 'reselect';
import TopUpTypes from '../types/TopUpTypes';
import { GridFilters, initialStateList } from './GridFiltersReducer';

const initialState = {
  topUps: { ...initialStateList },
  topUpDetails: {},
  foreignAccountTransferTypes: [],
  topUpCreditTypes: [],
  topUpCredits: {
    data: [],
    page: 0,
    maxRows: 0,
    rows: 0,
  },
};

export const TopUps = handleActions(
  {
    ...GridFilters,
    [TopUpTypes.actions.fetchTopUpDetailsSuccess]: (state, { payload }) => {
      return {
        ...state,
        topUps: { ...initialStateList },
        topUpDetails: payload,
      };
    },
    [TopUpTypes.actions.fetchTopUpCreditsSuccess]: (state, { payload }) => {
      const data = payload.page ? state.topUpCredits.data.concat(payload.data) : payload.data;
      const topUpCredits = { ...payload, data };
      return {
        ...state,
        topUpCredits,
      };
    },
    [TopUpTypes.actions.fetchTopUpTransferTypesSuccess]: (state, { payload }) => {
      return {
        ...state,
        foreignAccountTransferTypes: payload,
      };
    },
  },
  initialState
);

const getTopUps = (state) => state.TopUps;

export const getTopUpsList = (state, list) => {
  const topUps = getTopUps(state);
  return topUps[list] || undefined;
};

export const getTopUpDetails = createSelector(getTopUps, (state) => state.topUpDetails);

export const getTopUpCredits = createSelector(getTopUps, (state) => state.topUpCredits);

export const hasMore = (state) => {
  return state.topUpCredits ? state.topUpCredits.rows === state.topUpCredits.maxRows : false;
};

export const getTopUpTransferTypes = createSelector(getTopUps, (state) => state.foreignAccountTransferTypes);
